import { render, staticRenderFns } from "./ApproveCompany.vue?vue&type=template&id=0fdb70ab&scoped=true&"
import script from "./ApproveCompany.vue?vue&type=script&lang=js&"
export * from "./ApproveCompany.vue?vue&type=script&lang=js&"
import style0 from "./ApproveCompany.vue?vue&type=style&index=0&id=0fdb70ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb70ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VApp,VBtn,VDataTable,VIcon})
